import { render, staticRenderFns } from "./ImpressumTab.vue?vue&type=template&id=0c555990&scoped=true"
import script from "./ImpressumTab.vue?vue&type=script&lang=js"
export * from "./ImpressumTab.vue?vue&type=script&lang=js"
import style0 from "./ImpressumTab.vue?vue&type=style&index=0&id=0c555990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c555990",
  null
  
)

export default component.exports